import { PATIENT_STATUS } from "@home-health-notify/domain";
import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { getGroupStatusProperty } from "hhn-commons";
import { FormControlLayout } from "./AddPatientGroup.style";
import PatientHomeIcon from "../common/PatientHomeIcon";
import { MenuProps, StatusText } from "./PatientGroupStatus.style";

type PatientGroupStatusProps = {
  onSetStatus: (status: number) => void;
  status: string;
};
const PatientGroupStatus = ({
  onSetStatus,
  status,
}: PatientGroupStatusProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    onSetStatus(Number(event.target.value));
  };

  return (
    <FormControlLayout>
      <InputLabel id="selectStatus">Status *</InputLabel>
      <Select
        labelId="selectStatus"
        id="statusName"
        value={status}
        onChange={handleChange}
        MenuProps={MenuProps}
        label="Status"
        variant="standard"
        data-testid="status-select"
      >
        {Object.values(PATIENT_STATUS).map(function (i) {
          let patientStatus: string = String(i);
          let patientStatusTitle = getGroupStatusProperty(
            Number(patientStatus),
          ).title;
          return (
            <MenuItem
              key={patientStatus}
              value={patientStatus}
              data-testid={"menu-item-" + patientStatus}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center"
                }}>
                <div style={{ marginRight: 10 }}>
                  <PatientHomeIcon
                    size={38}
                    status={Number(patientStatus)}
                  />
                </div>
                <StatusText variant="subtitle1">
                  {patientStatusTitle}
                </StatusText>
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </FormControlLayout>
  );
};

export default PatientGroupStatus;
